import styled from 'styled-components/macro';

// eslint-disable-next-line import/prefer-default-export
export const StyledLocale = styled.span`
    margin: -20px 0 20px;
    color: #000;
    justify-content: flex-end;

    @media (max-width: 400px) {
        > .gx-language {
            display: none;
        }
    }

    > span {
        margin-left: 5px;
    }
`;
